// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { FeatureType } from "../schema";

export function serialize_FeatureType_internal(value: FeatureType): unknown {
  return ((value: "ACTIONABLE" | "GET_ABSTRACT_AI" | "MIAB" | "STUDIO" | "COPILOT" | "VERIFAI" | "MCP"): unknown => {
    return value;
  })(value);
}
export function serialize_FeatureType(obj: FeatureType): string {
  return renderJsonWithNumbersAsBigint(serialize_FeatureType_internal(obj));
}
export function deserialize_FeatureType_internal(value: unknown): ParserResult<FeatureType> {
  return ((value: unknown): ParserResult<"ACTIONABLE" | "GET_ABSTRACT_AI" | "MIAB" | "STUDIO" | "COPILOT" | "VERIFAI" | "MCP"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/FeatureType]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "ACTIONABLE":
        return { success: true, value: "ACTIONABLE" };
      case "GET_ABSTRACT_AI":
        return { success: true, value: "GET_ABSTRACT_AI" };
      case "MIAB":
        return { success: true, value: "MIAB" };
      case "STUDIO":
        return { success: true, value: "STUDIO" };
      case "COPILOT":
        return { success: true, value: "COPILOT" };
      case "VERIFAI":
        return { success: true, value: "VERIFAI" };
      case "MCP":
        return { success: true, value: "MCP" };
      default:
        return { success: false, reason: `[#/components/schemas/FeatureType]: '${value}' expected to be enum, one of 'ACTIONABLE, GET_ABSTRACT_AI, MIAB, STUDIO, COPILOT, VERIFAI, MCP'.` };
    }
  })(value);
}
export function deserialize_FeatureType(str: string): ParserResult<FeatureType> {
  return deserialize_FeatureType_internal(parseJsonWithNumbersAsBigint(str));
}
